export type ExpressFundingItem = {
  accountId: string
  title: string
  type: string
  amount?: string
  method?: string
  otherMethod?: string
  minimumDeposit?: number
  fundingMethodsAllowed?: string
  accountTermsUrl?: string
  productFeatures?: {
    impactCheckingDonationSelection?: boolean
  }
  primaryDebitCard?: boolean
  primaryDebitCardDesignId?: string
  jointDebitCard?: boolean
  jointDebitCardDesignId?: string
}

export type ExpressFundingPayload = {
  products: Array<{
    accountId: string
    title: string
    category: string
    amount: string
    method: string
    otherMethod?: string
    primaryDebitCard?: boolean
    primaryDebitCardDesignId?: string
    jointDebitCard?: boolean
    jointDebitCardDesignId?: string
  }>
}

export function buildExpressFundingPayload(
  fundingSnapshot: ExpressFundingItem[]
): ExpressFundingPayload {
  return {
    products: fundingSnapshot.map((funding) => ({
      accountId: funding.accountId,
      title: funding.title,
      category: funding.type || 'checking',
      amount: funding.amount || '0',
      method: funding.method || 'wire',
      otherMethod: funding.otherMethod,
      primaryDebitCard: funding.primaryDebitCard === true,
      primaryDebitCardDesignId: funding.primaryDebitCard ? funding.primaryDebitCardDesignId : undefined,
      jointDebitCard: funding.jointDebitCard === true,
      jointDebitCardDesignId: funding.jointDebitCard ? funding.jointDebitCardDesignId : undefined,
    })),
  }
}
